import { ReactNode } from 'react';
import { MuiGrid } from '../../../../../../../../modules/material';
import { GridProps as MuiGridProps } from '@mui/material/Grid';
import { StyledActionButtonWrapper, StyledPriceWrapper } from './styles';

export interface FirstLevelCardProps extends Omit<MuiGridProps, 'title'> {
  title: ReactNode;
  price: ReactNode;
  actionButton?: ReactNode;
  date?: ReactNode;
  description?: ReactNode;
  cardActive?: boolean;
}

export default function FirstLevelCard(props: FirstLevelCardProps) {
  const {
    title,
    price,
    actionButton,
    date,
    description,
    cardActive,
    ...gridProps
  } = props;

  return (
    <MuiGrid
      container
      rowSpacing={{ xs: 3, md: 0 }}
      columnSpacing={{ xs: 0, md: 1 }}
      {...gridProps}
    >
      <MuiGrid
        container
        item
        xs={12}
        md={cardActive ? 9 : 6}
        direction="column"
        justifyContent="center"
      >
        {date && <MuiGrid item>{date}</MuiGrid>}

        <MuiGrid item>{title}</MuiGrid>

        {description && (
          <MuiGrid item sx={{ mt: 1 }}>
            {description}
          </MuiGrid>
        )}
      </MuiGrid>

      <MuiGrid
        container
        item
        xs={12}
        md={cardActive ? 3 : 6}
        alignItems={cardActive ? 'flex-end' : 'center'}
        alignContent={{ md: 'center' }}
        justifyContent="flex-end"
      >
        <MuiGrid item xs={12} md="auto">
          <StyledPriceWrapper>{price}</StyledPriceWrapper>
        </MuiGrid>

        {!cardActive && actionButton && (
          <MuiGrid item xs={12} md="auto">
            <StyledActionButtonWrapper>
              {actionButton}
            </StyledActionButtonWrapper>
          </MuiGrid>
        )}
      </MuiGrid>
    </MuiGrid>
  );
}
